<template>
  <div class="auth-wrapper"></div>
</template>

<script>
  import { mapActions } from "vuex";
  import { formErrorMessage } from "@/utility/formErrorMessage";

  export default {
    name: "Autologin",
    async beforeMount() {
      const token = this.$route.query.token;
      if (token) {
        try {
          /**
           * Using fetch rather than the dataProvider since in case of invalid token, 401 is returned which causes token refresh request.
           */
          const response = await fetch(`${process.env.VUE_APP_API_URL}/auth/login/token`, {
            method: "POST",
            body: JSON.stringify({ token }),
            headers: {
              Accept: "application/ld+json",
              "Content-Type": "application/json",
            },
            credentials: "include",
          });

          const data = await response.json();

          if (response.status < 200 || response.status >= 300) {
            throw new Error(data["hydra:description"]);
          } else {
            if (data.result === "SUCCESS") {
              const { user } = data;
              this.$store.dispatch("SET_USER_DATA", user);
              /**
               * User having an organization here will probably never be the case, but leaving the
               * check just to be sure
               */
              if (user.organizations?.length) {
                this.$router.push({ name: "dashboard" });
              } else {
                this.$router.push({ name: "billing" });
              }
            }
          }
        } catch (err) {
          this.$admin.toast.error(formErrorMessage(err, this.$t("generic.error")));
          this.$router.push({ name: "login" });
        }
      } else {
        this.$router.push({ name: "login" });
      }
    },
    methods: {
      ...mapActions({
        refreshAndStoreAllUserData: "refreshAndStoreAllUserData",
      }),
    },
  };
</script>

<style lang="scss" scoped></style>
